<template>
  <v-dialog
    :value="true"
    persistent
    width="670px"
    :transition="false"
    content-class="dialogs-attempt-access-account-root"
  >
    <div
      class="dialogs-attempt-access-account-container d-flex flex-column"
    >
      <!--TITLE-->
      <div
        class="dialogs-attempt-access-account-title-container"
      >
        <v-icon
          size="28"
          class="mb-4"
          color="orange darken-1"
        >
          mdi mdi-alert-circle
        </v-icon>
        <h1 class="pa-0 dialogs-attempt-access-title">
          {{ $t('geoDialogs.title') }}
        </h1>
      </div>

      <!--CONTENT-->
      <div
        class="dialogs-attempt-access-content"
      >
        <p
          class="pa-0 dialogs-attempt-access-content-text-1"
        >
          {{ $t('geoDialogs.contentText1') }}
        </p>
        <div
          class="dialogs-attempt-access-user-info-block"
          :style="{ background: $vuetify.theme.dark ? '#424242' : '#F5F5F5' }"
        >
          <p class="dialogs-attempt-access-user-info-text pa-0">
            {{ $t('geoDialogs.time') }}
            <span class="dialogs-attempt-access-user-info">
              {{ $route.params.userInfo.time }}
            </span>
          </p>
          <p class="dialogs-attempt-access-user-info-text pa-0">
            {{ $t('geoDialogs.location') }}
            <span class="dialogs-attempt-access-user-info">
              {{ $route.params.userInfo.location }}
            </span>
          </p>
<!--                  <p class="dialogs-attempt-access-user-info-text pa-0">-->
<!--                    {{ $t('geoDialogs.operatingSystem') }}-->
<!--                    <span class="dialogs-attempt-access-user-info">-->
<!--                      {{ $t('geoDialogs.os') }}-->
<!--                    </span>-->
<!--                  </p>-->
                </div>
                <p
                  class="pa-0 dialogs-attempt-access-content-text-1"
                >
                  {{ $t('geoDialogs.contentText2') }}
                </p>
      </div>

      <!--INPUT-->
      <div class="dialogs-attempt-access-account-input-container">
        <p
          class="dialogs-attempt-access-account-input-label"
        >
          {{ $t('geoDialogs.inputLabel') }}
        </p>
        <div class="d-flex dialogs-attempt-access-account-input-block">
          <v-text-field
            v-model.trim.number="code"
            :placeholder="$t('geoDialogs.inputPlaceholder')"
            outlined
            dense
            hide-details="auto"
            :error="isError"
            :error-messages="$t(errorMassage)"
            class="dialogs-attempt-access-account-text-field rounded-lg"
            :success="isSuccess"
            :success-messages="$t(successMessage)"
            @keyup.enter="confirmCode"
          />
          <button
            class="dialogs-attempt-access-account-input-confirm-button"
            :disabled="disabled"
            @click="confirmCode"
          >
            {{ $t('geoDialogs.confirmButton') }}
          </button>
        </div>

        <!--ADDITIONAL BUTTONS-->
        <button
          v-if="isRateLimitExceeded"
          class="dialogs-attempt-access-account-input-additional-button"
          @click="openChat"
        >
          {{ $t('geoDialogs.writeToSupport') }}
        </button>
        <p
          v-else-if="timer && !isRateLimitExceeded && timerExpired"
          class="auth-reset-password-timer"
        >
          {{ $t('geoDialogs.timer', [timer]) }}
        </p>
        <button
          v-else
          class="dialogs-attempt-access-account-input-additional-button"
          @click="sendCode"
        >
          {{ $t('geoDialogs.additionalButton') }}
        </button>
      </div>

      <!--CAPTCHA-->
      <div
        v-if="showCaptcha"
        class="captcha"
      >
        <captcha-wrapper
          ref="captchaWrapper"
          captcha-id="attempt-access-account-captcha"
          :captcha-type="captchaType"
          @handle-captcha-response="handleCaptchaResponse"
        />
      </div>

      <!--TEXT-->
      <div>
        <span
          class="dialogs-attempt-access-account-text-2"
        >
          {{ $t('geoDialogs.text2') }}
        </span>
        <v-divider class="mt-4" />
      </div>

      <!--SECURITY TIP-->
      <div
        class="dialogs-attempt-access-account-security-tip dialogs-attempt-access-account-security-tip-text-2"
      >
        <span
          class="dialogs-attempt-access-account-security-tip-text-1"
        >
          {{ $t('geoDialogs.securityTipText1') }}
        </span>
        {{ $t('geoDialogs.securityTipText2') }}
        <span
          class="dialogs-attempt-access-account-security-tip-text-2"
        >
          {{ $t('geoDialogs.myAccount') }}
        </span>
        {{ $t('geoDialogs.securityTipText3') }}
        <img
          :src="imgByLang"
          height="136px"
        >
      </div>
    </div>
  </v-dialog>
</template>

<script>
import attemptEn from '@/assets/attempt-dialog-iamges/attemptEn.png'
import attemptRu from '@/assets/attempt-dialog-iamges/attemptRu.png'
import CaptchaWrapper from '@/components/CaptchaWrapper.vue'
import { MT_CAPTCHA_NAME } from '@/constants/auth/captcha'
import { getMathHeaders } from '@/utils/helpers'

export default {
  name: 'DialogsAttemptAccessAccount',
  components: { CaptchaWrapper },

  data () {
    return {
      code: '',
      tryToSendCodeCount: 0,
      captcha: null,
      isRateLimitExceeded: false,
      timerExpired: false,
      timer: localStorage.getItem('timer'),
      isError: false,
      isSuccess: false,
      errorMassage: '',
      successMessage: '',
      disabled: false,
      showCaptcha: false,
      captchaSiteKey: process.env.VUE_APP_H_CAPTCHA_KEY,
      isShowMtCaptcha: false,
      isShowHCaptcha: false,
      captchaType: MT_CAPTCHA_NAME
    }
  },

  created () {
    if (!this.$route.params.userInfo.userId) {
      this.$store.dispatch('main/closeDialogs', 'attemptAccessAccount')
    }

    if (localStorage.getItem('timer')) {
      this.startTimer()
    }
  },

  destroyed () {
    this.$route.params.userInfo = null
    this.tryToSendCodeCount = 0
  },

  computed: {
    imgByLang () {
      localStorage.setItem('i18nLang', this.$vuetify.lang.current)

      const localLang = localStorage.getItem('i18nLang')

      if (localLang && localLang === 'en') {
        return attemptEn
      }

      return attemptRu
    }
  },

  methods: {
    openExternalLink () {
      window.open(`${process.env.VUE_APP_LANDING_URL}/panel/#/overview`,'_self');
    },

    handleCaptchaResponse (verifiedToken) {
      this.forgotPassword.captcha = verifiedToken
    },

    async confirmCode () {
      this.disabled = true
      this.clearError()

      if (this.code === '') {
        this.code = ''
        this.errorMassage = 'geoDialogs.fieldRequired'
        this.isError = true
        this.disabled = false
        return
      }
      this.clearError()

      try {
        const mathHeaders = await getMathHeaders();
        const response = await this.api.post(
          'auth/two-factory-by-email',
          { ...this.$route.params.userInfo, code: this.code },
          { headers: {...this.api.headers, ...mathHeaders} }
        )

        if (response.status !== 200) {
          throw response
        }

        const { token: accessToken, refresh_token: refreshToken }  = response.data

        if (response.status === 200) {
          this.successMessage = 'geoDialogs.success'
          this.isSuccess = true
          setTimeout(() => {
            if (response.data.twoFactory) {
              this.$emit('toggleTwoFactor')
            } else {
              if (accessToken && refreshToken ) {
                this.$store.dispatch('main/loadProfileForVerification', {
                  accessToken,
                  refreshToken,
                })
              }
            }
          }, 2000)
        }
      } catch (e) {
        if (e.response.status === 401) {
          this.isError = true
          this.errorMassage = 'geoDialogs.invalidCode'
        }

        if (e.response.status === 422) {
          this.isError = true
          this.errorMassage = 'geoDialogs.invalidCode'
          this.isRateLimitExceeded = true
        }

        if (e.response.status === 429) {
          this.isRateLimitExceeded = true
          this.timerExpired = true
          this.isError = true
          this.errorMassage = 'geoDialogs.toManyAttempts'
        }
      } finally {
        this.disabled = false
      }
    },

    clearError () {
      this.isError = false
      this.errorMassage = ''
    },

    async sendCode () {
      const { password, username } = this.$route.params.userInfo
      const data = {
        username: username,
        password: password,
        captcha: this.captcha,
        count: ++this.tryToSendCodeCount
      }

      try {
        const response = await this.api.post('/auth/login', data, {
          headers: {
            'X-Content-Pragma': 'hard'
          }
        })

        if (response.status !== 200) {
          throw response
        } else {
          this.startTimer()
        }
      } catch (e) {
        if (this.showCaptcha) {
          this.resetCaptcha(this.captchaType, 'attempt-access-account-captcha', this.handleResetHcaptcha)
        }

        if (e.response && e.response.status === 400) {
          this.showCaptcha = true
          this.captchaType = e.response.data
        }

        if (e.response.status === 429) {
          this.isRateLimitExceeded = true
          this.isError = true
          this.errorMassage = 'geoDialogs.toManyAttempts'
        }
      }
    },

    startTimer () {
      this.timer = localStorage.getItem('timer') || 60
      this.timerExpired = true

      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--

          localStorage.setItem('timer', this.timer)
        } else {
          localStorage.removeItem('timer')

          clearInterval(interval)

          this.timerExpired = false
        }
      }, 1000)
    },

    handleResetHcaptcha() {
      this.$refs?.captchaWrapper.$refs.captcha?.reset()
    },

    openChat () {
      window.Intercom('show')
    }
  }
}
</script>

<style lang="scss">
.dialogs-attempt-access-account-root {
  border-radius: 24px;
}

.dialogs-attempt-access-account-root .error--text .v-messages__message {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.dialogs-attempt-access-account-root .success--text .v-messages__message {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.dialogs-attempt-access-account-container {
  border-radius: 24px;
  padding: 40px;
  background-color: #FFFFFF;
  gap: 20px;
}

.dialogs-attempt-access-title {
  color: var(--v-text-primary-base, #19181A);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}

.dialogs-attempt-access-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.dialogs-attempt-access-content-text-1 {
  color: var(--v-text-primary-base, #19181A);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0 !important;
}

.dialogs-attempt-access-user-info-block {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 4px;
  align-self: stretch;
}

.dialogs-attempt-access-user-info-text {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0 !important;
}

.dialogs-attempt-access-user-info {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.dialogs-attempt-access-account-input-container{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
}

.dialogs-attempt-access-account-input-label {
  color: var(--Input-input-label-default, #19181A);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0 !important;
}

.dialogs-attempt-access-account-input-block {
  gap: 16px;
  width: 100%;
}

.dialogs-attempt-access-account-input-confirm-button {
  height: 40px;
  padding: 0px 16px;
  border-radius: 8px;
  background: var(--v-button-primary-background-default-base);
  color: #FFFFFF;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.20), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.dialogs-attempt-access-account-input-additional-button {
  color: var(--v-primary-text-default-base, #B645EE);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  font-family: Roboto, sans-serif;
  display: flex;
  padding-bottom: 2px;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid var(--v-link-primary-border-default-base, #f4e3fd);
}

.dialogs-attempt-access-account-text-2 {
  color: var(--v-text-secondary-base, #7C797F);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  font-family: Roboto, sans-serif;
}

.dialogs-attempt-access-account-security-tip-text-1 {
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}

.dialogs-attempt-access-account-security-tip-text-2 {
  font-family: Robot, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 0;
}

.dialogs-attempt-access-account-text-field .v-text-field__details{
  margin: 0 !important;
  padding: 0 !important;
}

</style>
